import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 5% 95%;
  align-items: center;
  background-color: #080420;
  padding: 0 2rem;
  padding-bottom: 0.3rem;
  @media screen and (min-width: 720px) and (max-width: 1080px) {
    padding: 0 1.2rem;
    gap: 1rem;
  }
  .button-container {
    color: white;
    display: flex;
    gap: 1rem;
    align-items: center;
    .emoji {
      position: relative;
      svg {
        font-size: 1.5rem;
        color: #ffff00c7;
        cursor: pointer;
      }
      .EmojiPickerReact{
        position: fixed;
        top: 150px;
        background-color: #080420;
        box-shadow: 0 5p 10px #9a86f3;
        border-color: #9186f3;
        &::-webkit-scrollbar{
          display: none;
        }
        .epr-body::-webkit-scrollbar {
          background-color: #080420;
          width: 5px;
          &-thumb {
            background-color: #9a86f3;
          }
        }
        .epr-header > .epr-header-overlay >.epr-search-container > .epr-search {
          background-color: transparent;
          border-color: #9186f3;
        }
      }
    }
  }
  .input-container {
    width: 100%;
    border-radius: 2rem;
    display: flex;
    align-items: center;
    gap: 2rem;
    background-color: #ffffff34;
    input {
      width: 90%;
      background-color: transparent;
      color: white;
      border: none;
      padding-left: 1rem;
      font-size: 1.2rem;
      &::selection {
        background-color: #9186f3;
      }
      &:focus {
        outline: none;
      }
    }
    button {
      padding: 0.3em 2rem;
      border-radius: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #9a86f3;
      border: none;
      cursor: pointer;
      @media screen and (min-width: 720px) and (max-width: 1080px) {
        padding: 0.3rem 1rem;
        svg {
          font-size: 1rem;
        }
      }
      svg {
        font-size: 2rem;
        color: white;
      }
    }
  }
`;